import { FormFieldConfig } from '@shared/components/search-form/search-form.component';
import { TableColumn } from '@shared/components/data-table/data-table.component';
import { VirtualWarehouse } from './models/virtual-warehouse.model';

// ============================================================================
// INTERFACES
// ============================================================================

export type VirtualWarehouseItem = VirtualWarehouse;

// ============================================================================
// TABLE COLUMN CONFIGURATIONS
// ============================================================================

/**
 * Default column property names (shown on first load)
 * Update these constants to change column property names
 */
export const VIRTUAL_WAREHOUSE_DEFAULT_COLUMNS = {
  CODE: 'code',
  NAME: 'name',
  TYPE: 'typeCode',
  CITY_NAME: 'cityName',
  MEMBER_WAREHOUSE_NAMES: 'memberWarehouseNames',
  STATUS: 'status',
} as const;

/**
 * Flexible column property names (can be shown/hidden via column selector)
 * Update these constants to change flexible column property names
 */
export const VIRTUAL_WAREHOUSE_FLEXIBLE_COLUMNS = {
  CREATION_DATE: 'creationDate',
} as const;

/**
 * Action column property name
 */
export const VIRTUAL_WAREHOUSE_ACTION_COLUMN = {
  ACTIONS: 'actions',
} as const;

/**
 * Default columns order (shown on first load)
 * Update this array to change the default column order
 */
export const VIRTUAL_WAREHOUSE_DEFAULT_COLUMNS_ORDER: string[] = [
  VIRTUAL_WAREHOUSE_DEFAULT_COLUMNS.CODE,
  VIRTUAL_WAREHOUSE_DEFAULT_COLUMNS.NAME,
  VIRTUAL_WAREHOUSE_DEFAULT_COLUMNS.TYPE,
  VIRTUAL_WAREHOUSE_DEFAULT_COLUMNS.CITY_NAME,
  VIRTUAL_WAREHOUSE_DEFAULT_COLUMNS.MEMBER_WAREHOUSE_NAMES,
  VIRTUAL_WAREHOUSE_DEFAULT_COLUMNS.STATUS,
];

/**
 * Flexible columns array (can be shown/hidden via column selector)
 * Update this array to change which columns are flexible
 */
export const VIRTUAL_WAREHOUSE_FLEXIBLE_COLUMNS_ORDER: string[] = [
  VIRTUAL_WAREHOUSE_FLEXIBLE_COLUMNS.CREATION_DATE,
];

export const VIRTUAL_WAREHOUSE_COLUMNS: TableColumn[] = [
  {
    label: 'virtual_warehouse.table.columns.code',
    prop: VIRTUAL_WAREHOUSE_DEFAULT_COLUMNS.CODE,
    width: 120,
  },
  {
    label: 'virtual_warehouse.table.columns.name',
    prop: VIRTUAL_WAREHOUSE_DEFAULT_COLUMNS.NAME,
    width: 200,
  },
  {
    label: 'virtual_warehouse.table.columns.type',
    prop: VIRTUAL_WAREHOUSE_DEFAULT_COLUMNS.TYPE,
    type: 'custom',
    template: 'typeTemplate',
    width: 140,
  },
  {
    label: 'virtual_warehouse.table.columns.city_name',
    prop: VIRTUAL_WAREHOUSE_DEFAULT_COLUMNS.CITY_NAME,
    type: 'custom',
    template: 'cityNameTemplate',
    width: 150,
  },
  {
    label: 'virtual_warehouse.table.columns.member_warehouses',
    prop: VIRTUAL_WAREHOUSE_DEFAULT_COLUMNS.MEMBER_WAREHOUSE_NAMES,
    type: 'custom',
    template: 'memberWarehousesTemplate',
    width: 250,
  },
  {
    label: 'virtual_warehouse.table.columns.status',
    prop: VIRTUAL_WAREHOUSE_DEFAULT_COLUMNS.STATUS,
    type: 'status',
    width: 100,
  },
  {
    label: 'virtual_warehouse.table.columns.creation_date',
    prop: VIRTUAL_WAREHOUSE_FLEXIBLE_COLUMNS.CREATION_DATE,
    width: 135,
    type: 'custom',
    template: 'dateTemplate',
  },
  {
    label: 'virtual_warehouse.table.columns.actions',
    prop: VIRTUAL_WAREHOUSE_ACTION_COLUMN.ACTIONS,
    type: 'actions',
    width: 200,
  },
];

// ============================================================================
// SEARCH FORM CONFIGURATIONS
// ============================================================================

export const VIRTUAL_WAREHOUSE_SEARCH_CONFIG: FormFieldConfig[] = [
  {
    key: 'name',
    label: 'virtual_warehouse.search.fields.name',
    type: 'text',
    placeholder: 'virtual_warehouse.search.placeholders.enter_name',
  },
  {
    key: 'cityCode',
    label: 'virtual_warehouse.search.fields.city_name',
    type: 'searchableDropdown',
    placeholder: 'virtual_warehouse.search.placeholders.select_city',
  },
];

/** Search config for /v1/warehouses/virtual/page list: name, code, type, city. */
export const VIRTUAL_WAREHOUSE_PAGE_SEARCH_CONFIG: FormFieldConfig[] = [
  {
    key: 'name',
    label: 'virtual_warehouse.search.fields.name',
    type: 'text',
    placeholder: 'virtual_warehouse.search.placeholders.enter_name',
  },
  {
    key: 'code',
    label: 'virtual_warehouse.search.fields.code',
    type: 'text',
    placeholder: 'virtual_warehouse.search.placeholders.enter_code',
  },
  {
    key: 'typeCodes',
    label: 'virtual_warehouse.search.fields.type',
    type: 'multiselect',
    placeholder: 'virtual_warehouse.search.placeholders.select_type',
  },
  {
    key: 'cityCode',
    label: 'virtual_warehouse.search.fields.city_name',
    type: 'searchableDropdown',
    placeholder: 'virtual_warehouse.search.placeholders.select_city',
  },
];

